import React, {useMemo, useState} from "react";
import {Badge} from "./Badge.jsx";
import {SortHeader, sortRows} from "./SortButton.jsx";
import {metricClass, money, signed} from "../format.js";

export function PortfolioCards({portfolios}) {
    const [sort, setSort] = useState({field: "", direction: "desc"});
    const ordered = useMemo(() => sortRows(portfolios, sort, (portfolio, field) => portfolio[field] ?? null), [portfolios, sort]);
    const onSort = (field) => setSort((current) => ({
        field,
        direction: current.field === field ? (current.direction === "asc" ? "desc" : "asc") : ["name", "health"].includes(field) ? "asc" : "desc",
    }));
    if (!portfolios.length) return <div className="empty">No portfolios match this view.</div>;
    return (
        <div className="table-wrap">
            <table className="portfolio-table">
                <thead>
                    <tr>
                        <SortHeader
                            label="Portfolio" field="name" sort={sort}
                            onSort={onSort}
                        />
                        <SortHeader
                            label="Net P&L" field="netPnl" sort={sort}
                            onSort={onSort} numeric
                        />
                        <SortHeader
                            label="Risk" field="totalRiskUsd" sort={sort}
                            onSort={onSort} numeric
                        />
                        <SortHeader
                            label="Strategies" field="strategyCount" sort={sort}
                            onSort={onSort} numeric
                        />
                        <SortHeader
                            label="Health" field="health" sort={sort}
                            onSort={onSort}
                        />
                    </tr>
                </thead>
                <tbody>
                    {ordered.map((portfolio) => (
                        <tr className="clickable" key={portfolio.id}>
                            <td>
                                <a href={`#portfolio/${encodeURIComponent(portfolio.id)}`}>
                                    <strong>{portfolio.name}</strong>
                                    <div className="subtle mono">{portfolio.technicalName}</div>
                                </a>
                            </td>
                            <td className={`num ${metricClass(portfolio.netPnl)}`}>{signed(portfolio.netPnl)}</td>
                            <td className="num">{money(portfolio.totalRiskUsd)}</td>
                            <td className="num">{portfolio.strategyCount}</td>
                            <td>
                                <Badge value={portfolio.health}/>
                                {portfolio.warningCount ? (
                                    <div className="subtle">
                                        {portfolio.warningCount}
                                        {" "}
                                        warning
                                        {portfolio.warningCount === 1 ? "" : "s"}
                                    </div>
                                ) : null}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
